import { buildApiUrl } from "../api/apiClient";

const PMTILES_PROXY_PATH = "/pmtiles-proxy";
const DEFAULT_PMTILES_PROXY_HOST =
  "smaart-data-development-854575156978-eu-central-1-an.s3.eu-central-1.amazonaws.com";

const getPmtilesProxyHost = () =>
  process.env.REACT_APP_PMTILES_PROXY_HOST || DEFAULT_PMTILES_PROXY_HOST;

const parsePmtilesUrl = (url) => new URL(url, "https://placeholder.local");

const shouldUsePmtilesProxy = (url) => {
  if (process.env.REACT_APP_DISABLE_PMTILES_PROXY === "true") {
    return false;
  }

  try {
    return parsePmtilesUrl(url).hostname === getPmtilesProxyHost();
  } catch {
    return false;
  }
};

const buildPmtilesProxyUrl = (url) => {
  const parsedUrl = parsePmtilesUrl(url);

  return `${PMTILES_PROXY_PATH}${parsedUrl.pathname}${parsedUrl.search}`;
};

export const getFieldPmtilesUrl = (fieldData) => {
  if (!fieldData?.pm_tile) {
    return null;
  }

  let url = fieldData.pm_tile;

  if (typeof url === "object") {
    url = url.file_url || url.url || url.file || url.link || url.path || null;
  }

  if (typeof url !== "string") {
    return null;
  }

  if (!url.startsWith("http") && !url.startsWith("//")) {
    return buildApiUrl(url);
  }

  if (shouldUsePmtilesProxy(url)) {
    return buildPmtilesProxyUrl(url);
  }

  return url;
};
